<section class="section" id="about">
  <div class="container">
    <div class="section-head">
      <p class="eyebrow">À propos</p>
      <h2>{{ about.headline }}</h2>
      <p class="section-sub">{{ about.summary }}</p>
    </div>

    <div class="about-grid">
      <div class="about-card" appReveal>
        <h3>Ce qui me définit</h3>
        <ul>
          @for (item of about.highlights; track item) {
            <li>{{ item }}</li>
          }
        </ul>
      </div>
      <div class="about-card" appReveal>
        <h3>Positionnement</h3>
        <p>
          Je recherche des projets ambitieux où la qualité d'exécution, la fiabilité
          et la clarté des interfaces sont des priorités assumées.
        </p>
        <div class="signature">Draed / Nicolas Deruelle</div>
      </div>
    </div>
  </div>
</section>
